export default __webpack_public_path__ + "static/media/ag-icon-active.bdc91f7b.svg";